import { render, staticRenderFns } from "./inscricoes.vue?vue&type=template&id=5b0e41a9"
import script from "./inscricoes.vue?vue&type=script&lang=js"
export * from "./inscricoes.vue?vue&type=script&lang=js"
import style0 from "./inscricoes.vue?vue&type=style&index=0&id=5b0e41a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports